import React, { useEffect, useState } from "react";
import { informationUsed } from "@/setting";
import BuyerAgentAccordian from "./cif/BuyerAgentAccordian";
import Buyer from "./cif/Buyer";
import BuyersAgent from "./cif/BuyersAgent";
import ProofOfFunds from "./cif/ProofOfFunds";
import Submit from "./cif/Submit";
import { getUserProfile } from "@/api/bid";
import { cifFileUpload } from "@/api/placeOffer";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { trackPageMount } from "@/utils/analytics";
import { navigateToProperty } from "@/utils/propertyNavigation";

const INITIAL_ACCORDION_STATE = {
  accordion1: { close: false, disable: false, edit: false,visited:false },
  accordion2: { close: true, disable: true, edit: false,visited:false },
  accordion3: { close: true, disable: true, edit: false,visited:false },
  accordion4: { close: true, disable: true, edit: false,visited:false },
  accordion5: { close: true, disable: true, edit: false,visited:false },
};

const CifDetails = ({ offerDetails, cifId, setCifCompleted,setIsFromCif }) => {
  const { offerPage, listingId } = offerDetails || {};
  const { propertyDetails, isAgent, propertyId } = offerPage || {};
  const { address, imageDetails } = propertyDetails || {};
    const [buyerAgentDetails, setBuyerAgentDetails] = useState({});


  const [formState, setFormState] = useState({
    cifFormDetails: { userRole: isAgent ? "Agent" : "Buyer" },
    buyerAgent: false,
    pof: "",
    llc: "",
    profileDetails: null,
    accordionState: INITIAL_ACCORDION_STATE,
  });

  const {
    cifFormDetails,
    buyerAgent,
    pof,
    llc,
    profileDetails,
    accordionState,
  } = formState;

  useEffect(() => {
    // Track initial page load attempt
    trackPageMount({
      pageName: "cif_details_page_loaded",
      eventCategory: "Bid Cif Page",
      eventSource: "Page Load",
      eventLabel: `Listing Id: ${listingId}`
    });
  }, []);

  const fetchUserProfile = async () => {
    try {
      const { status, data } = await getUserProfile();
      if (status === "SESSION_REQUIRED") {
        navigate("/");
        return;
      }
      setFormState((prev) => ({ ...prev, profileDetails: data }));
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchFileConfig = async () => {
    try {
      const { status, data } = await cifFileUpload({ listingId });
      if (status === "SUCCESS") {
        setFormState((prev) => ({
          ...prev,
          pof: data?.pofConfig,
          llc: data?.llcConfig,
        }));
      }
    } catch (error) {
      console.error("Error fetching file config:", error);
    }
  };

  useEffect(() => {
    if (listingId) {
      Promise.all([fetchUserProfile(), fetchFileConfig()]);
    }
  }, [listingId]);

  useEffect(() => {
    setFormState((prev) => ({
      ...prev,
      cifFormDetails: {
        ...prev.cifFormDetails,
        userRole: isAgent ? "Agent" : "Buyer",
      },
    }));
  }, [offerDetails]);

  const updateAccordionState = (newState) => {
    setFormState((prev) => ({
      ...prev,
      accordionState: newState,
    }));
  };

  const updateCifFormDetails = (newDetails) => {
    setFormState((prev) => ({
      ...prev,
      cifFormDetails: { ...prev.cifFormDetails, ...newDetails },
    }));
  };

  const setBuyerAgentState = (value) => {
    setFormState((prev) => ({
      ...prev,
      buyerAgent: value,
    }));
  };
  if (!propertyId) {
    return (
      <div className="offer-loader p-5 mb-5">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      </div>
    );
  }
   const navigateToPdp = () => {
    navigateToProperty(`/property/${propertyId}`, propertyDetails?.commonAttributes?.propCategory, propertyDetails?.commonAttributes?.status);
  };

  return (
    <div className="cif-div">
      <div className="close-btn-cif">
        <img src="/assets/images/offerCloseIcon.png" className="x-btn-offer" alt="close icon" onClick={()=>navigateToPdp()} />
      </div>
      <div className="border">
        <h1 className="cif-heading text-center p-3">
          <strong>PROPERTY AND SALE CONTACT INFORMATION</strong>
        </h1>
        <section className="property-details">
          <div className="image-div">
            <img
              src={imageDetails?.length > 0 ? imageDetails?.[0]?.thumbnailUrl!=="https://s3.amazonaws.com/hubzu-core-images-dev/frontend/images/no-photo.jpg"?imageDetails?.[0]?.thumbnailUrl : "/assets/images/imageOnTheWay.webp" : "/assets/images/imageOnTheWay.webp"}
              alt="Image on the way"
               onClick={()=>navigateToPdp()}
               className="cursor-pointer"
            />
          </div>
          <div className="property-data font12 ">
            <p className="text-wrap add-cif-offer font12">
              The information contained within this document will be used to
              complete the contract documentation for the following property:
            </p>
            <p className="font12 add-cif-offer">{propertyId}</p>
            <p className="font12 add-cif-offer">
              {address?.streetNumber} {address?.streetName}
            </p>
            <p className="font12 add-cif-offer">
              {address?.city} , {address?.state}
            </p>
          </div>
        </section>{" "}
        <p className="info-used font12 border-top-heading">{informationUsed}</p>
        <div className="cif-data-body">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <BuyerAgentAccordian
              userRole={cifFormDetails.userRole}
              setBuyerAgent={setBuyerAgentState}
              setAccordionState={updateAccordionState}
              accordionState={accordionState}
            />
            <Buyer
              cifFormetails={cifFormDetails}
              setCifFormDetails={updateCifFormDetails}
              setAccordionState={updateAccordionState}
              accordionState={accordionState}
           profileDetails={
    profileDetails
  }
              llc={llc}
              listingId={listingId}
              buyerAgent={buyerAgent}
              pof={pof}
              validateEmail={(buyerAgent && cifFormDetails.userRole === "Agent" )?profileDetails?.userDetails?.emailId:""}
              cifId={cifId}
            />
            {buyerAgent && (
              <BuyersAgent
                cifFormetails={cifFormDetails}
                setCifFormDetails={updateCifFormDetails}
                setAccordionState={updateAccordionState}
                accordionState={accordionState}
                 profileDetails={
      cifFormDetails.userRole === "Agent"
        ? profileDetails // agent buying for someone else
        : null           // buyer – don't pass profileDetails
    }
                state={address?.state}
                pof={pof}
                 validateEmail={(buyerAgent && cifFormDetails.userRole === "Buyer" )?cifFormDetails?.buyer?.email:""}
                 propertyId={propertyId}
                 buyerAgentState={buyerAgent}
                 buyerAgentDetails={buyerAgentDetails}
                 setBuyerAgentDetails={setBuyerAgentDetails}
              />
            )}
            {pof === "Optional" || pof === "Required" ? (
              <ProofOfFunds
                cifFormetails={cifFormDetails}
                setCifFormDetails={updateCifFormDetails}
                setAccordionState={updateAccordionState}
                accordionState={accordionState}
                pof={pof}
                listingId={listingId}
                cifId={cifId}
                setCifCompleted={setCifCompleted}
                setIsFromCif={setIsFromCif}
                buyerAgentState={buyerAgent}
              />
            ) : (
              <Submit
                cifFormetails={cifFormDetails}
                setCifFormDetails={updateCifFormDetails}
                setAccordionState={updateAccordionState}
                accordionState={accordionState}
                cifId={cifId}
                setCifCompleted={setCifCompleted}
                setIsFromCif={setIsFromCif}
                buyerAgentState={buyerAgent}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CifDetails;
